import ClosableElement from '../closable-element'


class DetailsManager {
    constructor() {
        this._init()
    }
    _init() {
        this.elDetails = document.querySelectorAll('[data-details]')
        if(this.elDetails.length == 0) {
            return
        }
        this.elDetails.forEach(el => {
            el.detail = new Detail(el, this)
            el.closable = new ClosableElement(el, () => {
                // if(!this.isMobile())
                // {
                    el.open = false
                // }
            })
        })
        this.elBody = document.querySelector('[data-body]')
    }
    closeDetails(except = null) {
        this.elDetails.forEach(el => {
            if(el.detail.id !== except){
                setTimeout(function() { el.open = false }, 1)
            }  
        })
    }
	isMobile() {
		return !window.matchMedia("only screen and (min-width: 1024px)").matches
	}
}

class Detail {
    constructor(el, manager) {
        this._init(el, manager)
    }
    _init(el, manager) {
        this.el = el
        this.manager = manager
        this.id = this.el.getAttribute('data-details')
        this.elAction = this.el.querySelector('[data-details-action]')
        if(this.elAction) {
            this.elAction.addEventListener("click", () => this.onDetailClick())            
        }
        this.elClose = this.el.querySelector('[data-details-close]')
        if(this.elClose) {
            this.elClose.addEventListener("click", () => this.closeThisDetails())
        }
    }
	closeThisDetails() {
		this.el.open = false
	}
    onDetailClick() {
        if(this.manager.isMobile()) {
            // this.manager.closeDetails(this.id)
            this.disableBodyOverflow(this.el.open) 
        }
    }
    disableBodyOverflow(b) {
        if(b) {
            this.manager.elBody.style.overflow = 'auto'
        } else {
            this.manager.elBody.style.overflow = 'hidden'
        }
    }
}

export default DetailsManager